import React from 'react';
import { Button, Grid } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

function ShareFooter() {
  const email = window.config.supportEmail;
  const appTerms = window.config.appTerms;
  const policy = window.config.appPolicy;
  const status = window.config.appStatus;
  // const release = window.config.release;
  const handleClick = () => {
    const subject = 'ZenSign Help Request';
    window.location.href = `mailto:${email}?subject=${encodeURIComponent(subject)}`;
  };

  const PartitionLine = () => {
    return <span className="partition-line"> | </span>;
  };

  return (
    <div className="footer">
      <Grid columns={1} stackable>
        <Grid.Column textAlign="center">
          <Button onClick={handleClick} className="support-button">
            <FormattedMessage id="footer.support" defaultMessage="Support" />
          </Button>
          <>
            <span>
              <FormattedMessage id="footer.poweredBySimple" defaultMessage="© ZenQMS LLC " />
            </span>
            <PartitionLine />
            <span>
              <a href={appTerms} target="_blank" className="add-comma-separator" rel="noreferrer">
                <FormattedMessage id="footer.terms" defaultMessage="Terms" />
              </a>
              <a href={policy} target="_blank" className="add-separator" rel="noreferrer">
                <FormattedMessage id="footer.privacy" defaultMessage="Privacy" />
              </a>
              <a href={status} target="_blank" className="add-separator-ampersand-before" rel="noreferrer">
                <FormattedMessage id="footer.status" defaultMessage="Status" />
              </a>
            </span>
            {/* <PartitionLine />
            <span> {release}</span> */}
          </>
        </Grid.Column>
      </Grid>
    </div>
  );
}

export default ShareFooter;
